import React from 'react'

function CookiePolicy() {
  return (
    <div className="bg-background-secondary-color rounded-lg p-6 font-popins lg:m-[100px] mt-5">
      <h2 className="text-3xl font-extrabold text-btn-color mb-10">Cookie Policy</h2>
      <div className="space-y-8 max-w-4xl">

        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-btn-color" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeWidth="round" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-semibold text-white">Use of Cookies</h3>
            <p className="text-sm text-white mt-4">
              At <span className="text-btn-color-500 font-bold">FinzAid.com</span>, we use cookies to enhance your browsing experience. Cookies are small data files that are stored on your device when you visit our website. They help us understand your preferences and improve the user experience.
            </p>
          </div>
        </div>

        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-btn-color" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeWidth="round" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-semibold text-white">Types of Cookies</h3>
            <p className="text-sm text-white mt-4">
              We use different types of cookies, including:
            </p>
            <ul className="list-disc list-inside text-sm text-white">
              <li><strong>Essential Cookies:</strong> These cookies are necessary for the website to function and cannot be switched off in our systems.</li>
              <li><strong>Performance Cookies:</strong> These cookies help us understand how visitors interact with the site by collecting and reporting information anonymously.</li>
              <li><strong>Functional Cookies:</strong> These cookies enable the website to provide enhanced functionality and personalization.</li>
              <li><strong>Targeting Cookies:</strong> These cookies are used to display relevant advertisements to users based on their interests.</li>
            </ul>
          </div>
        </div>

        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-btn-color" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeWidth="round" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-semibold text-white">Managing Cookies</h3>
            <p className="text-sm text-white mt-4">
              You can control and manage cookies through your browser settings. However, please note that disabling certain cookies may affect your ability to use certain parts of the site.
            </p>
          </div>
        </div>

        <div className="flex items-start">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-btn-color" fill="none" stroke="currentColor" viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeWidth="round" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div className="ml-4">
            <h3 className="text-lg font-semibold text-white">Changes to This Policy</h3>
            <p className="text-sm text-white mt-4">
              We may update our Cookie Policy from time to time. We encourage you to review this policy periodically to stay informed about how we use cookies.
            </p>
          </div>
        </div>

      </div>
    </div>
  )
}

export default CookiePolicy;
